import * as actionTypes from '../../constants/action-types/school';

const INIT_STATE = {
    school: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case actionTypes.FETCH_SCHOOL_SUCCESS:
            return {...action.payload.school};

        default:
            return {...state};
    }
};
